import { authenticatedFetchWithRefresh } from '../utils/enhancedTokenManager';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Get apartments by building ID
export const getListApartmensByBuildingId = async (buildingId) => {
  try {
    const response = await authenticatedFetchWithRefresh(`${API_URL}/api/apartment/list?buildingId=${buildingId}`);

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || 'getApartmensByBuildingId failed');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};